module.exports = __webpack_public_path__ + "static/img/zbbl1-1.67c37d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zbbl1-1.png
// module id = 810
// module chunks = 0